export default __webpack_public_path__ + "static/support-sponsor-changecx-616ae246dfd9ddb72c9f5706c25db29c.png";